const DEV = process.env.NODE_ENV === 'development'

export default {
  init() {
    const contents = document.querySelectorAll('.registered_nl_content')

    contents.forEach((div) => {
      const paragraphs = div.querySelectorAll('p, ul, ol')
      paragraphs.forEach((p, index) => {
        if (index % 3 === 0) p.classList.add('plain')
      })
    })

    document.addEventListener('evolokUserReady', (e) => {
      if (e.detail.loggedOut === false) {
        contents.forEach((div) => {
          div.classList.add('loggedin')
        })
        var banner = document.getElementById('nlSubscriptionBanner')
        if (banner) banner.style.display = 'none'
      }
    })
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
}
